import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { config } from '../../function/config'
import { toast } from 'react-toastify'
import AdminHeader from './AdminHeader'
import { useNavigate } from 'react-router-dom'
import { FaEdit, FaToggleOff, FaToggleOn, FaTrashAlt, FaUserPlus } from 'react-icons/fa'

export default function AllStaffs() {
  const token = localStorage.getItem('token')
  const navigate = useNavigate()
  const [staffs, setStaffs] = useState([])
  const [selectedStaff, setSelectedStaff] = useState(null)

  const fetchStaffs = async() => {
    try{
      const res = await axios.get(`${config.baseurl}get_admin_staffs/`, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })
      console.log('Staff Res:', res.data)

      if(res.status === 200){
        setStaffs(res.data.data)
      }else{
        toast.error('Failed to fetch staffs')
      }
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Staff'

      toast.error(message)
    }
  }

  useEffect(() => {
    fetchStaffs()
  },[token])
  console.log('Staffs:', staffs)

  const handleDelete = async(id) => {
    console.log('Staff Id:', id)

    if(!id){
      toast.error('Invalid Staff id')
      return
    }

    try{
      const res = await axios.delete(`${config.baseurl}delete_staff/${id}/`,{
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success('Staff Deleted Successfully')
      await fetchStaffs()
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Staff'

      toast.error(message)
    }
  }

  const handleStatus = async(id) => {
    console.log('Staff Id:', id)

    if(!id){
      toast.error('Invalid Staff id')
      return
    }

    try{
      const res = await axios.put(`${config.baseurl}activate_staff/${id}/`, {}, {
        headers:{
          'Content-Type':'application/json',
          'Authorization':`Token ${token}`
        }
      })

      toast.success('Staff Status Changed Successfully')
      await fetchStaffs()
    }catch (error) {
      console.error('Error:', error.response?.data || error)

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Failed to create Staff'

      toast.error(message)
    }
  }

  return (
    <div className='min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-slate-100 ml-64 5xl:ml-0'>
      <AdminHeader/>

      <div className='max-w-7xl mx-auto px-6 pt-16 pb-6 items-center justify-between text-center'>
        <h1 className='mt-1 text-3xl font-bold'>
          ALL Staffs
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          View and manage all registered staffs in one place.
        </p>
      </div>

        <div className='max-w-7xl mx-auto px-6 pb-10'>
          <div className='bg-white rounded-lg shadow-sm border border-slate-300 overflow-hidden'>
          <div className='overflow-x-auto'>
            <table className='w-full table-auto'>
              <thead>
                <tr className='text-center border-b border-slate-300'>
                  <th className='px-3 py-2 whitespace-nowrap'>No</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Staff Name</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Role</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Department</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Email</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Phone Number</th>
                  <th className='px-3 py-2 whitespace-nowrap'>Actions</th>
                </tr>
              </thead>

              <tbody>
                {staffs.length > 0 ? (
                  staffs.map((item, index) => (
                    <tr
                      key={item.id}
                      className='text-center border-b border-b-slate-300 cursor-pointer'
                      onClick={(e) => {
                        if(e.target.closest('button')){
                          return
                        }

                        navigate(`/admin/staff_overview/${item.id}`,{state:item})
                      }}
                    >
                      <td className='px-3 py-2 whitespace-nowrap'>{index + 1}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.first_name} {item.last_name}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.role}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.department_name}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.email}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>{item.phone}</td>
                      <td className='px-3 py-2 whitespace-nowrap'>
                        <div className='flex items-center justify-center gap-3'>
                          <button
                            title='Edit'
                            onClick={(e) => {
                              e.stopPropagation()
                              setSelectedStaff(item)
                              navigate(`/admin/edit_staff/${item.id}`)
                            }}
                            className='bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600'
                          >
                            <FaEdit/>
                          </button>

                          <button
                            title='Delete'
                            onClick={(e) => {
                              e.stopPropagation()
                              handleDelete(item.id)
                            }}
                            className='bg-red-500 text-white px-3 py-2 rounded-lg hover:bg-red-600'
                          >
                            <FaTrashAlt/>
                          </button>

                          <button
                            title={item.is_active ? 'Deactivate' : 'Activate'}
                            onClick={(e) => {
                              e.stopPropagation()
                              handleStatus(item.id)
                            }}
                            className={`text-white px-3 py-2 rounded-lg ${
                              item.is_active
                                ? 'bg-green-500 hover:bg-green-600'
                                : 'bg-slate-500 hover:bg-slate-600'
                            }`}
                          >
                            {item.is_active ? <FaToggleOn/> : <FaToggleOff/>}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={6}
                      className='text-center py-6'
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}
